import { workflowTrackBy } from '../common/employee-assets/asset.helpers';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { OffboardingCase, OffboardingMutation } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey, assetOperationId } from '../common/employee-assets/asset.helpers';
import { OFFBOARDING as O } from './offboarding.constants';

@Component({selector: 'app-offboarding-action-modal', templateUrl: './offboarding-action-modal.component.html',
  styleUrls: ['../common/employee-assets/asset-form.component.css']})
export class OffboardingActionModalComponent implements OnInit, OnDestroy {
  trackBy = workflowTrackBy;
  item: OffboardingCase;
  action: string;
  draft: OffboardingMutation;
  constants = O;
  assetConstants = ASSET;
  errorKey = ASSET.empty;
  busy = false;
  confirmed = false;
  dateProposalAction = false;
  private disposed = false;
  private destroyed = new Subject<void>();
  constructor(public modal: NgbActiveModal, private api: OffboardingService) {}
  ngOnInit(): void {
    this.draft = {operationId: assetOperationId(), expectedVersion: this.item.version,
      action: this.action};
    this.dateProposalAction = this.action === O.proposeDates;
    if (this.dateProposalAction) {
      this.draft.terminationDate = this.item.terminationDate;
      this.draft.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || O.defaultZone;
    }
  }
  ngOnDestroy(): void { this.disposed = true; this.destroyed.next(); this.destroyed.complete(); }
  submit(): void {
    if (this.disposed || this.busy || !this.confirmed) { return; }
    this.busy = true;
    this.api.act(this.item.id, this.draft).takeUntil(this.destroyed).subscribe(result => this.modal.close(result),
      error => { this.busy = false; this.errorKey = assetErrorKey(error, true); });
  }
  refresh(): void {
    if (this.disposed || this.busy) { return; }
    this.busy = true;
    this.api.get(this.item.id).takeUntil(this.destroyed).subscribe(result => {
      this.item = result; this.draft.expectedVersion = result.version;
      this.draft.operationId = assetOperationId(); this.confirmed = false;
      this.busy = false; this.errorKey = ASSET.empty;
      this.checkRefreshedPermission(result);
    }, error => { this.busy = false; this.errorKey = assetErrorKey(error, false); });
  }
  private checkRefreshedPermission(result: OffboardingCase): void {
    if (result.allowedActions.indexOf(this.action) < ASSET.zero) { this.errorKey = ASSET.deniedKey; }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-action-modal.component.ts